import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Ideology } from "../../../parts/kor/intro/ideology";
export const IDEOLOGY = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <Ideology />
      </div>
      <FOOTER />
    </main>
  );
};
